<template>
  <el-dialog class="password"
             :visible.sync="passwordVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             :modal-append-to-body="false"
             append-to-body
             width="600px"
             title="修改密码">
    <el-form :model="passwordForm"
             ref="passwordForm"
             label-width="100px"
             class="formCont" @keydown.enter.native.prevent>
      <el-form-item prop="password"
                    :rules="[{ required: true, message: '请输入新密码' }]"
                    label="新密码"
                    size="small">
        <el-input placeholder="请输入新密码"
                  maxlength="100"
                  size="small"
                  v-model="passwordForm.password">
        </el-input>
      </el-form-item>
      <el-form-item prop="passwordAgain"
                    label="确认密码"
                    :rules="[{ required: true, message: '请再次输入新密码' }]"
                    size="small">
        <el-input placeholder="请输入再次新密码"
                  maxlength="100"
                  size="small"
                  v-model="passwordForm.passwordAgain">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="passwordVisible = false"
                 size="small">取 消</el-button>
      <el-button type="primary"
                 @click="changePwd"
                 size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            passwordForm: {
                password: "",
                passwordAgain: "",
            },
        };
    },
    methods: {
        /**
         * 修改密码提交
         */
        changePwd() {
            this.$refs["passwordForm"].validate((valid) => {
                if (valid) {
                    if (
                        this.passwordForm.password ==
                        this.passwordForm.passwordAgain
                    ) {
                        erpApi
                            .changePwd(
                                {
                                    newpassword: this.passwordForm.password,
                                },
                                "post"
                            )
                            .then((res) => {
                                this.passwordVisible = false;
                                this.$message.success("修改成功");
                                if (res) {
                                    this.$router.push({
                                        path: "/login",
                                    });
                                }
                            });
                    } else {
                        this.$message.error("两次输入的密码不同");
                    }
                }
            });
        },
        /**
         * 修改密码弹窗 关闭事件
         */
        closeDialog() {
            this.passwordForm = {
                password: "",
                passwordAgain: "",
            };
            this.$refs["passwordForm"].resetFields();
            this.$refs["passwordForm"].clearValidate();
            this.$emit("update:passwordVisible", false);
        },
    },
    props: {
        passwordVisible: Boolean,
    },
};
</script>